"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledError = exports.StyledLabel = exports.StyledInput = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  padding-top: 4px;\n  color: ", ";\n  text-transform: ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n          border-style: none none solid none;\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n          border-radius: ", ";\n          border-style: solid;\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        border-style: none;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  &:required {\n    box-shadow: none;\n  }\n  font: initial;\n  height: ", ";  \n  width: 100%;\n  box-sizing: border-box;\n  background: ", ";\n  border: 1px;\n  ", ";\n\n  border-color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  color: ", ";\n  opacity: ", ";\n  padding: ", ";\n\n  cursor: ", ";\n  pointer-events: ", ";\n  transition: border-color ", ",\n    box-shadow ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    ", ";\n    outline: none;\n    + ", " {\n      ", ";\n    }\n  }\n\n  &:valid {\n    + ", " {\n      ", ";\n    }\n  }\n\n  &::-webkit-input-placeholder {\n    transition: all ", ";\n    color: ", ";\n    opacity: 1;\n  }\n\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ::after {\n      content: '*';\n      color: ", ";\n      margin-left: 5px;\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          opacity: 0.5;\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", ";\n  top:  ", ";\n  color: ", ";\n  opacity: ", ";\n  transition: all ", ";\n  pointer-events: none;\n  ", ";\n  \n  ", ";\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          box-shadow: 0px 1px 0 0px\n            ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          box-shadow: 0px 0px 0 1px\n            ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    opacity: 1;\n    left: 0;\n    top: 0;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var large = {
  height: '38px',
  left: {},
  top: {
    "default": '27px',
    bordered: '30px',
    textarea: {
      "default": '27px',
      bordered: '30px'
    }
  }
};
var medium = {
  height: '27px',
  top: {
    "default": '22px',
    bordered: '35px',
    textarea: {
      "default": '20px',
      bordered: '25px'
    }
  }
};

var getColors = function getColors(props) {
  var inputColors = (0, _versions.getColor)(props, 'input');
  var textColors = (0, _versions.getColor)(props, 'text');
  return {
    inputColors: inputColors,
    textColors: textColors
  };
};

var getViews = function getViews(props) {
  var colors = getColors(props).inputColors;
  return {
    "default": {
      background: colors.background,
      border: colors.border,
      hoverBorder: colors.borderHover,
      focusBorder: colors.borderFocus,
      placeholder: colors.placeholder
    },
    readOnly: {
      background: colors.backgroundReadOnly,
      border: colors.border,
      hoverBorder: colors.border,
      focusBorder: colors.border,
      placeholder: colors.placeholderReadOnly
    },
    error: {
      background: colors.background,
      border: colors.borderError,
      hoverBorder: colors.borderError,
      focusBorder: colors.borderError
    }
  };
};

var getInputColorsForView = function getInputColorsForView(props) {
  var views = getViews(props);
  if (props.readOnly) return views.readOnly;
  if (props.error) return views.error;
  return views["default"];
};

var getFloatedStyle = function getFloatedStyle(props) {
  var floatedCSS = (0, _styledComponents.css)(_templateObject());
  return floatedCSS;
};

var getBoxShadow = function getBoxShadow(props) {
  if (!props.boxShadow) {
    return;
  }

  return (0, _styledComponents.css)(_templateObject2(), function (props) {
    return props.bordered ? (0, _styledComponents.css)(_templateObject3(), function (props) {
      return getInputColorsForView(props).focusBorder;
    }) : (0, _styledComponents.css)(_templateObject4(), function (props) {
      return getInputColorsForView(props).focusBorder;
    });
  });
};

var StyledLabel = _styledComponents["default"].label(_templateObject5(), function (props) {
  var value = 0;

  if (!props.textarea) {
    if (props.bordered) {
      value = 12;
    }

    if (props.icon) {
      value = 36;
    }

    if (props.icon && !props.bordered) {
      value = 25;
    }
  } else {
    if (props.bordered) {
      value = 20;
    }
  }

  if (props.bordered && props.iconBordered) {
    value = value + 12;
  }

  return value + 'px';
}, function (props) {
  var value;

  if (!props.textarea) {
    if (props.size === 'large') {
      value = props.bordered ? large.top.textarea.bordered : large.top.textarea["default"];
    } else {
      value = props.bordered ? medium.top.textarea.bordered : medium.top.textarea["default"];
    }
  } else {
    if (props.size === 'large') {
      value = props.bordered ? large.top.bordered : large.top["default"];
    } else {
      value = props.bordered ? medium.top.bordered : medium.top["default"];
    }
  }

  return value;
}, function (props) {
  return getColors(props).textColors["default"];
}, function (props) {
  return props.readOnly ? 0.5 : 1;
}, _tokens.misc.animationDuration, function (props) {
  return props.readOnly ? getFloatedStyle(props) : (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.labelType === 'static' && getFloatedStyle(props);
}, function (props) {
  return props.required && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return getColors(props).inputColors.borderError;
  });
});

exports.StyledLabel = StyledLabel;

var StyledInput = _styledComponents["default"].input.attrs(function (_ref) {
  var name = _ref.name,
      autoFocus = _ref.autoFocus,
      autoComplete = _ref.autoComplete;
  return {
    name: name,
    autoFocus: autoFocus,
    autoComplete: autoComplete
  };
})(_templateObject8(), function (props) {
  var height = props.height;
  if (props.textarea) return 'initial';

  if (props.size === 'large') {
    return height.large;
  }

  if (props.size === 'medium') {
    return height.medium;
  }
}, function (props) {
  return getInputColorsForView(props).background;
}, function (props) {
  if (props.noInputUnderline) {
    return (0, _styledComponents.css)(_templateObject9());
  }

  return props.bordered ? (0, _styledComponents.css)(_templateObject10(), props.radius) : (0, _styledComponents.css)(_templateObject11());
}, function (props) {
  return getInputColorsForView(props).border;
}, function (props) {
  return props.code ? _tokens.fonts.family.code : 'inherit';
}, function (props) {
  return getColors(props).textColors.inputs;
}, function (props) {
  return props.readOnly ? 0.7 : 1;
}, function (props) {
  var leftValue = 0;

  if (props.bordered) {
    leftValue = 12;
  }

  if (props.icon) {
    leftValue = 36;
  }

  if (props.icon && props.iconBordered) {
    leftValue = 48;
  }

  if (props.icon && !props.bordered) {
    leftValue = 25;
  }

  if (props.size === 'large') {
    return "8px ".concat(props.rightIcon ? '50px' : '8px', " 8px ").concat(leftValue, "px ");
  } else {
    return "4px ".concat(props.rightIcon ? '50px' : '4px', " 4px ").concat(leftValue, "px ");
  }
}, function (props) {
  return props.readOnly ? 'not-allowed' : 'auto';
}, function (props) {
  return props.readOnly ? 'none' : 'auto';
}, _tokens.misc.animationDuration, _tokens.misc.animationDuration, function (props) {
  return getInputColorsForView(props).hoverBorder;
}, function (props) {
  return getInputColorsForView(props).focusBorder;
}, function (props) {
  return getBoxShadow(props);
}, StyledLabel, function (props) {
  return getFloatedStyle(props);
}, StyledLabel, function (props) {
  return getFloatedStyle(props);
}, _tokens.misc.animationDuration, function (props) {
  return getInputColorsForView(props).placeholder;
});

exports.StyledInput = StyledInput;

var StyledError = _styledComponents["default"].div(_templateObject12(), function (props) {
  return props.errorSize;
}, function (props) {
  return getColors(props).inputColors.borderError;
}, function (props) {
  return props.errorCasing;
});

exports.StyledError = StyledError;